import * as constants from './constants';

export const processState = {
  LQCTA: {
    SFU: {
      nextStep: 'LQACK',
      previousStep: 'ADDRESSENTRY',
    },
    CJU: {
      nextStep: 'LQACK',
      previousStep: 'ADDRESSENTRY',
    },
    MDU: {
      nextStep: 'LQACK',
      previousStep: 'ADDRESSENTRY',
    },
  },
  LQACK: {
    SFU: {
      nextStep: 'ORDERNOW',
      previousStep: 'ADDRESSENTRY',
    },
    CJU: {
      nextStep: 'ORDERNOW',
      previousStep: 'ADDRESSENTRY',
    },
    MDU: {
      nextStep: 'UBERPIN',
      previousStep: 'ADDRESSENTRY',
    },
  },
  Landing: {
    NSE: {
      nextStep: 'Plans',
      nextViewPage: 'plans.html',
      currentStep: 'Landing',
      previousStep: 'ADDRESSENTRY',
    },
    AAL: {
      nextStep: 'SendLink',
      nextViewPage: 'sendlink.html',
      currentStep: 'Landing',
      previousStep: 'ADDRESSENTRY',
    },
    PlansOverview: {
      nextStep: 'PlansOverview',
      nextViewPage: 'plansOverview.html',
      currentStep: 'Landing',
      previousStep: 'ADDRESSENTRY',
    },
    TechCbandSendLink: {
      nextStep: 'SendLink',
      nextViewPage: 'sendlink.html',
      currentStep: 'Landing',
      previousStep: 'TechExpressCart',
    },
  },
  SendLink: {
    NSE: {
      nextStep: 'CreditCheck',
      nextViewPage: 'creditcheck.html',
      currentStep: 'SendLink',
      previousStep: 'ContactInfo',
    },
    AAL: {
      nextStep: 'Plans',
      nextViewPage: 'plans.html',
      currentStep: 'SendLink',
      previousStep: 'Landing',
    },
    PlansOverview: {
      nextStep: 'PlansOverview',
      nextViewPage: 'plansOverview.html',
      currentStep: 'SendLink',
      previousStep: 'Landing',
    },
  },
  ExpressCart: {
    nextStep: 'Plans',
    nextViewPage: 'plans.html',
    currentStep: 'ExpressCart',
    previousStep: 'AEM',
  },
  ResumeCart: {
    nextStep: 'Cart',
    nextViewPage: 'cart.html',
    currentStep: 'ResumeCart',
    previousStep: 'AEM',
  },
  PackageSelection: {
    BuildPackage: {
      nextStep: 'Addons',
      currentStep: 'PackageSelection',
      nextViewPage: 'addons.html',
      previousStep: 'ADDRESSENTRY',
    },
    Select: {
      nextStep: 'Cart',
      currentStep: 'PackageSelection',
      nextViewPage: 'cart.html',
      previousStep: 'ADDRESSENTRY',
    },
    Covid: {
      nextStep: 'Covid',
      nextViewPage: 'setup/covid.html',
      currentStep: 'PackageSelection',
      previousStep: 'ADDRESSENTRY',
    },
  },
  Plans: {
    Addons: {
      nextStep: 'Addons',
      currentStep: 'Plans',
      nextViewPage: 'addons.html',
      previousStep: 'ADDRESSENTRY',
    },
    ExpressCart: {
      nextStep: 'ExpressCart',
      nextViewPage: 'expresscart.html?NoBundle=Y',
      currentStep: 'plans',
      previousStep: 'ExpressCart',
    },
  },
  PlansNew: {
    Addons: {
      nextStep: 'Addons',
      currentStep: 'PlansNew',
      nextViewPage: 'addons.html',
      previousStep: 'ADDRESSENTRY',
    },
    ExpressCart: {
      nextStep: 'ExpressCart',
      nextViewPage: 'expresscart.html?NoBundle=Y',
      currentStep: 'PlansNew',
      previousStep: 'ExpressCart',
    },
  },
  PlansOverview: {
    Addons: {
      nextStep: 'AddonsCBand',
      currentStep: 'PlansOverview',
      nextViewPage: 'addons.html',
      previousStep: 'ADDRESSENTRY',
    },
    ExpressCart: {
      nextStep: 'ExpressCart',
      nextViewPage: 'expresscart.html?NoBundle=Y',
      currentStep: 'PlansOverview',
      previousStep: 'ExpressCart',
    },
    Edit: {
      nextStep: 'Cart',
      nextViewPage: 'cart.html',
      currentStep: 'PlansOverview',
      previousStep: 'Cart',
    },
    EditWHW: {
      nextStep: 'AddonsCBand',
      nextViewPage: 'addons.html',
      currentStep: 'PlansOverview',
      previousStep: 'Cart',
    },
  },

  Addons: {
    FiveG: {
      nextStep: 'Setup',
      nextViewPage: 'setup.html',
      currentStep: 'Addons',
      previousStep: 'Plans',
    },
    LTE: {
      nextStep: 'Cart',
      nextViewPage: 'cart.html',
      currentStep: 'Addons',
      previousStep: 'Plans',
    },
    Edit: {
      nextStep: 'Cart',
      nextViewPage: 'cart.html',
      currentStep: 'Addons',
      previousStep: 'Cart',
    },
    CBandFiveG: {
      nextStep: 'Cart',
      nextViewPage: 'cart.html',
      currentStep: 'Addons',
      previousStep: 'PlansOverview',
    },
    Redemption: {
      nextStep: 'Shipping',
      nextViewPage: 'shipping.html',
      currentStep: 'Addons',
      previousStep: 'CPC',
    },
    ExpressCheckout: {
      nextStep: 'ExpressCheckout',
      nextViewPage: 'expresscheckout.html',
      currentStep: 'Addons',
      previousStep: 'Addons',
    },
  },
  Setup: {
    SELF: {
      nextStep: 'Cart',
      nextViewPage: 'cart.html',
      currentStep: 'Setup',
      previousStep: 'Addons',
    },
    PRO: {
      nextStep: 'Covid',
      nextViewPage: 'setup/covid.html',
      currentStep: 'Setup',
      previousStep: 'Addons',
    },
    ProCovid: {
      nextStep: 'Cart',
      nextViewPage: 'cart.html',
      currentStep: 'Setup',
      previousStep: 'Addons',
    },
    ExpressCheckout: {
      nextStep: 'ExpressCheckout',
      nextViewPage: 'expresscheckout.html',
      currentStep: 'Setup',
      previousStep: 'Addons',
    },
  },
  Covid: {
    nextStep: 'Cart',
    nextViewPage: 'cart.html',
    currentStep: 'Covid',
    previousStep: 'Setup',
  },
  Cart: {
    nextStep: 'ContactInfo',
    nextViewPage: 'contactinfo.html',
    currentStep: 'Cart',
    previousStep: 'Setup',
    editSetupPage: 'setup.html',
    editPage: 'addons.html',
    editAddonsStep: 'addons.html',
    editStep: 'Addons',
    editPlansPage: 'plansOverview.html',
    editPlansStep: 'PlansOverview',
    PREORDER: {
      nextStep: 'OrderReview',
      nextViewPage: 'orderreview.html',
      currentStep: 'ContactInfo',
      previousStep: 'Cart',
    },
    SELF: {
      nextStep: 'Shipping',
      nextViewPage: 'shipping.html',
      currentStep: 'ContactInfo',
      previousStep: 'Cart',
    },
    PRO: {
      Payment: {
        nextStep: 'Payment',
        nextViewPage: 'payment.html',
        currentStep: 'ContactInfo',
        previousStep: 'Cart',
      },
      Tos: {
        nextStep: 'Tos',
        nextViewPage: 'tos.html',
        currentStep: 'ContactInfo',
        previousStep: 'Cart',
      },
      OrderReview: {
        nextStep: 'OrderReview',
        nextViewPage: 'orderreview.html',
        currentStep: 'ContactInfo',
        previousStep: 'Cart',
      },
    },
    CreditStatus: {
      nextStep: 'CreditStatus',
      nextViewPage: 'creditstatus.html',
      currentStep: 'ContactInfo',
      previousStep: 'Cart',
    },
    SendLink: {
      nextStep: 'SendLink',
      nextViewPage: 'sendlink.html',
      currentStep: 'ContactInfo',
      previousStep: 'Cart',
    },
    CreditCheck: {
      nextStep: 'CreditCheck',
      nextViewPage: 'creditcheck.html',
      currentStep: 'ContactInfo',
      previousStep: 'Cart',
    },
    OrderReview: {
      nextStep: 'OrderReview',
      nextViewPage: 'orderreview.html',
      currentStep: 'Shipping',
      previousStep: 'ContactInfo',
    },
    Payment: {
      nextStep: 'Payment',
      nextViewPage: 'payment.html',
      currentStep: 'Shipping',
      previousStep: 'ContactInfo',
    },
  },
  ContactInfo: {
    PREORDER: {
      nextStep: 'OrderReview',
      nextViewPage: 'orderreview.html',
      currentStep: 'ContactInfo',
      previousStep: 'Cart',
    },
    SELF: {
      nextStep: 'Shipping',
      nextViewPage: 'shipping.html',
      currentStep: 'ContactInfo',
      previousStep: 'Cart',
    },
    PRO: {
      Payment: {
        nextStep: 'Payment',
        nextViewPage: 'payment.html',
        currentStep: 'ContactInfo',
        previousStep: 'Cart',
      },
      Tos: {
        nextStep: 'Tos',
        nextViewPage: 'tos.html',
        currentStep: 'ContactInfo',
        previousStep: 'Cart',
      },
      OrderReview: {
        nextStep: 'OrderReview',
        nextViewPage: 'orderreview.html',
        currentStep: 'ContactInfo',
        previousStep: 'Cart',
      },
    },
    CreditStatus: {
      nextStep: 'CreditStatus',
      nextViewPage: 'creditstatus.html',
      currentStep: 'ContactInfo',
      previousStep: 'Cart',
    },
    SendLink: {
      nextStep: 'SendLink',
      nextViewPage: 'sendlink.html',
      currentStep: 'ContactInfo',
      previousStep: 'Cart',
    },
    CreditCheck: {
      nextStep: 'CreditCheck',
      nextViewPage: 'creditcheck.html',
      currentStep: 'ContactInfo',
      previousStep: 'Cart',
    },
    OrderReview: {
      nextStep: 'OrderReview',
      nextViewPage: 'orderreview.html',
      currentStep: 'Shipping',
      previousStep: 'ContactInfo',
    },
    Payment: {
      nextStep: 'Payment',
      nextViewPage: 'payment.html',
      currentStep: 'Shipping',
      previousStep: 'ContactInfo',
    },
    ExpressCheckout: {
      nextStep: 'ExpressCheckout',
      nextViewPage: 'expresscheckout.html',
      currentStep: 'ContactInfo',
      previousStep: 'Addons',
    },
  },
  CreditCheck: {
    CreditSuccess: {
      nextStep: 'CreditStatus',
      nextViewPage: 'creditstatus.html',
      currentStep: 'CreditCheck',
      previousStep: 'ContactInfo',
    },
    ExpressCart: {
      nextStep: 'ExpressCart',
      nextViewPage: 'expresscart.html?NoBundle=Y',
      currentStep: 'CreditCheck',
      previousStep: 'ContactInfo',
    },
    OrderReview: {
      nextStep: 'OrderReview',
      nextViewPage: 'orderreview.html',
      currentStep: 'CreditCheck',
      previousStep: 'ContactInfo',
    },
    Payment: {
      nextStep: 'Payment',
      nextViewPage: 'payment.html',
      currentStep: 'CreditCheck',
      previousStep: 'ContactInfo',
    },
    CreditHold: {
      nextStep: 'CreditHold',
      nextViewPage: 'creditstatus.html',
      currentStep: 'CreditCheck',
      previousStep: 'ContactInfo',
    },
    d2dEidSuccess: {
      nextStep: 'EidStatus',
      nextViewPage: 'eidstatus.html',
      currentStep: 'CreditCheck',
      previousStep: 'CreditCheck',
    },
    D2dBackEidSuccess: {
      nextStep: 'SendLink',
      nextViewPage: 'sendlink.html',
      currentStep: 'EidStatus',
      previousStep: 'CreditCheck',
    },
    EdgeIneligible: {
      nextStep: 'CreditEdgeInEligible',
      nextViewPage: 'creditedgeInEligible.html',
      currentStep: 'CreditCheck',
      previousStep: 'CreditCheck',
    },
    CreditDownPayment: {
      nextStep: 'DownPayment',
      nextViewPage: 'downpayment.html',
      currentStep: 'CreditCheck',
      previousStep: 'ContactInfo',
    },
    TosPage: {
      nextStep: 'TOS',
      nextViewPage: 'tos.html',
      currentStep: 'CreditCheck',
      previousStep: 'ContactInfo',
    },
  },
  CreditEdgeInEligible: {
    nextStep: 'Payment',
    nextViewPage: 'payment.html',
    currentStep: 'CreditEdgeInEligible',
    previousStep: 'CreditCheck',
  },
  PaypalIntermediate: {
    Paypal: {
      nextStep: 'Payment',
      nextViewPage: 'payment.html',
      currentStep: 'PaypalIntermediate',
      previousStep: 'Payment',
    },
    NoSlotsAppointment: {
      nextStep: 'Appointment',
      nextViewPage: 'appointment.html',
      currentStep: 'Payment',
      previousStep: 'Appointment',
    },
    OrderReview: {
      nextStep: 'OrderReview',
      nextViewPage: 'orderreview.html',
      currentStep: 'Payment',
      previousStep: 'Shipping',
    },
    ExpressTOS: {
      nextStep: 'ExpressTOS',
      nextViewPage: 'expresstos.html',
      currentStep: 'Payment',
      previousStep: 'ExpressCheckout',
    },
  },
  DownPayment: {
    nextStep: 'Payment',
    nextViewPage: 'payment.html',
    currentStep: 'DownPayment',
    previousStep: 'CreditCheck',
  },
  EidStatus: {
    nextStep: 'CreditStatus',
    nextViewPage: 'creditstatus.html',
    currentStep: 'CreditCheck',
    previousStep: 'ContactInfo',
  },
  Shipping: {
    Payment: {
      nextStep: 'Payment',
      nextViewPage: 'payment.html',
      currentStep: 'Shipping',
      previousStep: 'ContactInfo',
    },
    Tos: {
      nextStep: 'Tos',
      nextViewPage: 'tos.html',
      currentStep: 'Shipping',
      previousStep: 'ContactInfo',
    },
    CreditStatus: {
      nextStep: 'CreditStatus',
      nextViewPage: 'creditstatus.html',
      currentStep: 'Shipping',
      previousStep: 'ContactInfo',
    },
    NoSlotsAppointment: {
      nextStep: 'Appointment',
      nextViewPage: 'appointment.html',
      currentStep: 'Shipping',
      previousStep: 'Appointment',
    },
    OrderReview: {
      nextStep: 'OrderReview',
      nextViewPage: 'orderreview.html',
      currentStep: 'Shipping',
      previousStep: 'ContactInfo',
    },
    CreditCheck: {
      nextStep: 'CreditCheck',
      nextViewPage: 'creditcheck.html',
      currentStep: 'Shipping',
      previousStep: 'ContactInfo',
    },
    SendLink: {
      nextStep: 'SendLink',
      nextViewPage: 'sendlink.html',
      currentStep: 'Shipping',
      previousStep: 'ContactInfo',
    },
    ExpressCheckout: {
      nextStep: 'ExpressCheckout',
      nextViewPage: 'expresscheckout.html',
      currentStep: 'Shipping',
      previousStep: 'ContactInfo',
    },
  },
  CreditStatus: {
    CreditCheck: {
      nextStep: 'CreditCheck',
      nextViewPage: 'creditcheck.html',
      currentStep: 'CreditStatus',
      previousStep: 'ContactInfo',
    },
    TosPage: {
      nextStep: 'TOS',
      nextViewPage: 'tos.html',
      currentStep: 'CreditStatus',
      previousStep: 'ContactInfo',
    },
    Success: {
      nextStep: 'Shipping',
      nextViewPage: 'shipping.html',
      currentStep: 'CreditStatus',
      previousStep: 'ContactInfo',
    },
    DownPayment: {
      nextStep: 'DownPayment',
      nextViewPage: 'downpayment.html',
      currentStep: 'CreditStatus',
      previousStep: 'Shipping',
    },
    Payment: {
      nextStep: 'Payment',
      nextViewPage: 'payment.html',
      currentStep: 'CreditStatus',
      previousStep: 'ContactInfo',
    },
    SecurityDeposit: {
      nextStep: 'Payment',
      nextViewPage: 'payment.html',
      currentStep: 'CreditStatus',
      previousStep: 'Shipping',
    },
    EdgeInEligible: {
      nextStep: 'CreditEdgeInEligible',
      nextViewPage: 'creditedgeInEligible.html',
      currentStep: 'CreditStatus',
      previousStep: 'Shipping',
    },
    OrderReview: {
      nextStep: 'OrderReview',
      nextViewPage: 'orderreview.html',
      currentStep: 'CreditCheck',
      previousStep: 'ContactInfo',
    },
    CreditHold: {
      nextStep: 'CreditStatus',
      nextViewPage: 'creditstatus.html',
      currentStep: 'CreditStatus',
      previousStep: 'Shipping',
    },
    ExpressCheckout: {
      nextStep: 'ExpressCheckout',
      nextViewPage: 'expresscheckout.html',
      currentStep: 'CreditStatus',
      previousStep: 'Addons',
    },
  },
  Payment: {
    Tos: {
      nextStep: 'Tos',
      nextViewPage: 'tos.html',
      currentStep: 'Payment',
      previousStep: 'Shipping',
    },
    NoSlotsAppointment: {
      nextStep: 'Appointment',
      nextViewPage: 'appointment.html',
      currentStep: 'Payment',
      previousStep: 'Appointment',
    },
    OrderReview: {
      nextStep: 'OrderReview',
      nextViewPage: 'orderreview.html',
      currentStep: 'Payment',
      previousStep: 'Shipping',
    },
    ExpressCheckout: {
      nextStep: 'ExpressCheckout',
      nextViewPage: 'expresscheckout.html',
      currentStep: 'Payment',
      previousStep: 'Addons',
    },
    ExpressTOS: {
      nextStep: 'ExpressTOS',
      nextViewPage: 'expresstos.html',
      currentStep: 'Payment',
      previousStep: 'ExpressCheckout',
    },
  },
  Tos: {
    nextStep: 'OrderReview',
    nextViewPage: 'orderreview.html',
    currentStep: 'Tos',
    previousStep: 'Payment',
  },

  ReviewOrder: {
    EdgeInEligible: {
      nextStep: 'Payment',
      nextViewPage: 'payment.html',
      currentStep: 'ReviewOrder',
      previousStep: 'CreditStatus',
    },
    FiveG: {
      nextStep: 'Appointment',
      nextViewPage: 'appointment.html',
      currentStep: 'ReviewOrder',
      previousStep: 'Tos',
    },
    LTE: {
      nextStep: 'Confirmation',
      nextViewPage: 'confirmation.html',
      currentStep: 'ReviewOrder',
      previousStep: 'Tos',
    },
    CBandFiveG: {
      nextStep: 'Confirmation',
      nextViewPage: 'confirmation.html',
      currentStep: 'ReviewOrder',
      previousStep: 'Tos',
    },
    PFS: {
      nextStep: 'Payment',
      nextViewPage: 'payment.html',
      currentStep: 'ReviewOrder',
    },
  },
  OrderReview: {
    FiveG: {
      nextStep: 'Appointment',
      nextViewPage: 'appointment.html',
      currentStep: 'ReviewOrder',
      previousStep: 'Tos',
    },
    LTE: {
      nextStep: 'Confirmation',
      nextViewPage: 'confirmation.html',
      currentStep: 'ReviewOrder',
      previousStep: 'Tos',
    },
    NSE_LTE: {
      nextStep: 'Registration_LTE',
      nextViewPage: 'registration.html',
      currentStep: 'ReviewOrder',
      previousStep: 'Tos',
    },
    PFS: {
      nextStep: 'Payment',
      nextViewPage: 'payment.html',
      currentStep: 'ReviewOrder',
    },
    CBandFiveG: {
      nextStep: 'Registration',
      nextViewPage: 'registration.html',
      currentStep: 'ReviewOrder',
      previousStep: 'Tos',
    },
    CBandD2DFiveG: {
      nextStep: 'Confirmation',
      nextViewPage: 'confirmation.html',
      currentStep: 'ReviewOrder',
      previousStep: 'Tos',
    },
    Registration: {
      nextStep: 'Registration',
      nextViewPage: 'registration.html',
      currentStep: 'ReviewOrder',
      previousStep: 'Tos',
    },
    Confirmation: {
      nextStep: 'Confirmation',
      nextViewPage: 'confirmation.html',
      currentStep: 'ReviewOrder',
      previousStep: 'Tos',
    },
  },
  Appointment: {
    nextStep: 'Confirmation',
    nextViewPage: 'confirmation.html',
    currentStep: 'Appointment',
    previousStep: 'ReviewOrder',
    noSLots: 'shipping.html',
    noSLotsStep: 'Shipping',
    TOSROUTE: {
      nextStep: 'ExpressTOS',
      nextViewPage: 'expresstos.html',
      currentStep: 'Appointment',
      previousStep: 'ExpressCheckout',
    },
    PFS: {
      nextStep: 'Payment',
      nextViewPage: 'payment.html',
      currentStep: 'Appointment',
    },
    NSE: {
      nextStep: 'Registration',
      nextViewPage: 'registration.html',
      currentStep: 'Appointment',
      previousStep: 'ReviewOrder',
      noSLots: 'shipping.html',
      noSLotsStep: 'Shipping',
    },
    TOSEXPRESS: {
      previousStep: 'ExpressTOS',
      noSLots: 'expresscheckout.html',
      noSLotsStep: 'ExpressCheckout',
      nextStep: 'Confirmation',
      nextViewPage: 'confirmation.html',
      currentStep: 'Appointment',
    },
  },
  Registration: {
    nextStep: 'Confirmation',
    nextViewPage: 'confirmation.html',
    currentStep: 'Registration',
    previousStep: 'Appointment',
  },
  Registration_LTE: {
    nextStep: 'Confirmation',
    nextViewPage: 'confirmation.html',
    currentStep: 'Registration_LTE',
    previousStep: 'ReviewOrder',
  },
  Confirmation: {
    nextStep: 'Home',
    nextViewPage: '/',
    currentStep: 'Confirmation',
    previousStep: 'Appointment',
  },
  EupExpressCart: {
    nextStep: 'EupDevicesetup',
    nextViewPage: 'eupdevicesetup.html',
    currentStep: 'EupExpressCart',
    previousStep: 'AEM',
  },
  EupPendingOrder: {
    currentStep: 'EupCart',
    nextStep: 'EupOrderreview',
    nextViewPage: 'euppendingorder.html',
    previousStep: 'eupeExpressCart',
  },
  EupDevicesetup: {
    nextStep: 'EupCart',
    nextViewPage: 'eupcart.html',
    currentStep: 'EupDevicesetup',
    previousStep: 'EupExpressCart',
  },
  EupCart: {
    nextStep: 'EupOrderreview',
    nextViewPage: 'euporderreview.html',
    currentStep: 'EupCart',
    previousStep: 'EupDevicesetup',
  },
  EupOrderreview: {
    nextStep: 'EupConfirmation',
    nextViewPage: 'eupconfirmation.html',
    currentStep: 'EupOrderreview',
    previousStep: 'EupCart',
  },
  EupConfirmation: {
    nextStep: 'Home',
    nextViewPage: '/',
    currentStep: 'EupConfirmation',
    previousStep: 'EupOrderreview',
  },
  TechExpressCart: {
    nextStep: 'landing',
    nextViewPage: 'landing.html',
    currentStep: 'TechExpressCart',
    previousStep: 'TechExpressCart',
  },
  CpcExpressCart: {
    nextStep: 'cpclanding',
    nextViewPage: 'cpclanding.html',
    currentStep: 'CpcExpressCart',
    previousStep: 'CpcExpressCart',
  },
  CpcLanding: {
    nextStep: 'cpcsendlink',
    nextViewPage: 'cpcsendlink.html',
    currentStep: 'cpclanding',
    previousStep: 'CpcExpressCart',
  },
  CpcSendLink: {
    nextStep: 'cpcverifypin',
    nextViewPage: 'cpcverifypin.html',
    currentStep: 'cpcsendlink',
    previousStep: 'CpcLanding',
  },
  CpcReviewOrder: {
    CpcPlanInfo: {
      nextStep: 'cpcplaninfo',
      nextViewPage: 'cpcplaninfo.html',
      currentStep: 'cpcrevieworder',
      previousStep: 'cpcverifypin',
    },
    CpcOrderConfirmation: {
      nextStep: 'cpcorderconfirmation',
      nextViewPage: 'cpcorderconfirmation.html',
      currentStep: 'cpcrevieworder',
      previousStep: 'cpcverifypin',
    },
  },
  CpcVerifyPin: {
    nextStep: 'cpcrevieworder',
    nextViewPage: 'cpcrevieworder.html',
    currentStep: 'cpcverifypin',
    previousStep: 'CpcSendlink',
  },
  whwExpressCart: {
    nextStep: 'whwlanding',
    nextViewPage: 'whwlanding.html',
    currentStep: 'whwExpressCart',
    previousStep: 'whwExpressCart',
  },
  WhwLanding: {
    nextStep: 'whwsendlink',
    nextViewPage: 'whwsendlink.html',
    currentStep: 'whwlanding',
    previousStep: 'whwExpressCart',
  },
  WhwSendLink: {
    nextStep: 'whwverifypin',
    nextViewPage: 'whwverifypin.html',
    currentStep: 'whwsendlink',
    previousStep: 'WhwLanding',
  },
  WhwReviewOrder: {
    WhwOrderConfirmation: {
      nextStep: 'whwrderconfirmation',
      nextViewPage: 'whworderconfirmation.html',
      currentStep: 'whwrevieworder',
      previousStep: 'whwverifypin',
    },
  },
  WhwVerifyPin: {
    nextStep: 'whwrevieworder',
    nextViewPage: 'whwrevieworder.html',
    currentStep: 'whwverifypin',
    previousStep: 'WhwSendlink',
  },
  ExpressCheckout: {
    nextStep: 'ExpressTOS',
    nextViewPage: 'expresstos.html',
    currentStep: 'ExpressCheckout',
    previousStep: 'Setup',
    editSetupPage: 'setup.html',
    editAddonsPage: 'addons.html',
    editAddonsStep: 'Addons',
    editPlansPage: 'progressiveplan.html',
    editPlansStep: 'PlansOverview',
    FiveG: {
      nextStep: 'TermandCondition',
      nextViewPage: 'appointment.html',
      currentStep: 'ExpressCheckout',
      previousStep: 'ExpressCheckout',
    },
    LTE: {
      nextStep: 'Confirmation',
      nextViewPage: 'confirmation.html',
      currentStep: 'termandCondition',
      previousStep: 'ExpressCheckout',
    },
    Payment: {
      nextStep: 'Payment',
      nextViewPage: 'payment.html',
      currentStep: 'ExpressCheckout',
      previousStep: 'Addons',
    },
    Shipping: {
      nextStep: 'Shipping',
      nextViewPage: 'shipping.html',
      currentStep: 'ExpressCheckout',
      previousStep: 'Addons',
    },
    ContactInfo: {
      nextStep: 'ContactInfo',
      nextViewPage: 'contactinfo.html',
      currentStep: 'ExpressCheckout',
      previousStep: 'Addons',
    },
    ExpressTOS: {
      nextStep: 'ExpressTOS',
      nextViewPage: 'expresstos.html',
      currentStep: 'ExpressCheckout',
      previousStep: 'Addons',
    },
    Appointment: {
      nextStep: 'Appointment',
      nextViewPage: 'appointment.html',
      currentStep: 'ExpressCheckout',
      previousStep: 'Addons',
    },
    CreditStatus: {
      nextStep: 'CreditStatus',
      nextViewPage: 'creditstatus.html',
      currentStep: 'ExpressCheckout',
      previousStep: 'Addons',
    },
  },
  ExpressTOS: {
    FiveG: {
      nextStep: 'Appointment',
      nextViewPage: 'appointment.html',
      currentStep: 'ExpressTOS',
      previousStep: 'ExpressCheckout',
    },
    LTE: {
      nextStep: 'Confirmation',
      nextViewPage: 'confirmation.html',
      currentStep: 'ExpressTOS',
      previousStep: 'ExpressCheckout',
    },
    PFS: {
      nextStep: 'Payment',
      nextViewPage: 'payment.html',
      currentStep: 'ExpressTOS',
    },
  },
};

const progressState = {
  Service: {
    isCompleted: true,
    isActive: true,
    progress: 20,
  },
  'Add-Ons': {
    isCompleted: false,
    isActive: false,
    progress: 40,
  },
  Cart: {
    isCompleted: false,
    isActive: false,
    progress: 60,
  },
  Checkout: {
    isCompleted: false,
    isActive: false,
    progress: 80,
  },
  Schedule: {
    isCompleted: false,
    isActive: false,
    progress: 100,
  },
};
export const progressSteps = (state = progressState, action) => {
  switch (action.type) {
    case constants.UPDATE_PLANS:
    case constants.UPDATE_PLANSOVERVIEW: {
      const service = { ...state.Service, isCompleted: action.response, isActive: action.response };
      const disableAddon = { ...state['Add-Ons'], isCompleted: false };
      const disableCart = { ...state.Cart, isCompleted: false };
      const disableCheckOut = { ...state.Checkout, isCompleted: false };
      const disableSchedule = { ...state.Schedule, isCompleted: false };
      return {
        ...state,
        Service: service,
        'Add-Ons': disableAddon,
        Cart: disableCart,
        Checkout: disableCheckOut,
        Schedule: disableSchedule,
      };
    }
    case constants.UPDATE_PACKAGESELECTION: {
      const service = { ...state.Service, isCompleted: action.response, isActive: action.response };
      const disableCart = { ...state.Cart, isCompleted: false };
      const disableCheckOut = { ...state.Checkout, isCompleted: false };
      const disableSchedule = { ...state.Schedule, isCompleted: false };
      // eslint-disable-next-line no-param-reassign
      delete state['Add-Ons'];
      return {
        ...state,
        Service: service,
        Cart: disableCart,
        Checkout: disableCheckOut,
        Schedule: disableSchedule,
      };
    }
    case constants.UPDATE_ADDONS:
    case constants.UPDATE_ADDONSCBAND:
    case constants.UPDATE_SETUP:
    case constants.UPDATE_COVID: {
      const service = { ...state.Service, isActive: false };
      const addons = {
        ...state['Add-Ons'],
        isCompleted: action.response,
        isActive: action.response,
        progress: 40,
      };
      const disableCart = { ...state.Cart, isCompleted: false };
      const disableCheckOut = { ...state.Checkout, isCompleted: false };
      const disableSchedule = { ...state.Schedule, isCompleted: false };
      return {
        ...state,
        Service: service,
        'Add-Ons': addons,
        Cart: disableCart,
        Checkout: disableCheckOut,
        Schedule: disableSchedule,
      };
    }
    case constants.UPDATE_CART: {
      const cart = { ...state.Cart, isCompleted: action.response, isActive: action.response };
      const enableAddons = { ...state['Add-Ons'], isCompleted: true, isActive: false };
      const disableCheckOut = { ...state.Checkout, isCompleted: false };
      const disableSchedule = { ...state.Schedule, isCompleted: false };
      return {
        ...state,
        'Add-Ons': enableAddons,
        Cart: cart,
        Checkout: disableCheckOut,
        Schedule: disableSchedule,
      };
    }
    case constants.UPDATE_CONTACTINFO:
    case constants.UPDATE_REVIEWORDER:
    case constants.UPDATE_CREDITCHECK:
    case constants.UPDATE_PAYMENT:
    case constants.UPDATE_SHIPPING:
    case constants.UPDATE_CREDITSTATUS:
    case constants.UPDATE_ORDERREVIEW:
    case constants.UPDATE_TOS: {
      const checkout = { ...state.Checkout, isCompleted: action.response, isActive: action.response };
      const enableCart = { ...state.Cart, isCompleted: true, isActive: false };
      const enableAddons = { ...state['Add-Ons'], isCompleted: true, isActive: false };
      const disableSchedule = { ...state.Schedule, isCompleted: false };
      return {
        ...state,
        'Add-Ons': enableAddons,
        Cart: enableCart,
        Checkout: checkout,
        Schedule: disableSchedule,
      };
    }
    case constants.UPDATE_APPOINTMENT: {
      const schedule = { ...state.Schedule, isCompleted: action.response, isActive: action.response };
      const enableCheckout = { ...state.Checkout, isCompleted: true, isActive: false };
      const enableCart = { ...state.Cart, isCompleted: true, isActive: false };
      const enableAddons = { ...state['Add-Ons'], isCompleted: true, isActive: false };
      return {
        ...state,
        'Add-Ons': enableAddons,
        Cart: enableCart,
        Checkout: enableCheckout,
        Schedule: schedule,
      };
    }
    default:
      return state;
  }
};

export const processSteps = (state = processState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
